module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio57-f6a7a5adccd9dd0b29d98a5d0b801a19.m4a";